import type { ApiError } from "@cx/contracts";

export class ApiFailure extends Error {
  override name = "ApiFailure";
  constructor(
    public status: number,
    public code: string,
    message: string,
    public fields?: Record<string, string>,
  ) {
    super(message);
  }
}

/** companyId vai como argumento: nada de estado global mutável alterado durante o render (FE9). */
export type ApiInit = RequestInit & { companyId?: string | null };

export async function apiFetch<T>(path: string, init: ApiInit = {}): Promise<T> {
  const { companyId, ...rest } = init;
  const headers = new Headers(rest.headers);
  if (companyId) headers.set("x-company-id", companyId);
  if (rest.body && !(rest.body instanceof FormData) && !headers.has("content-type"))
    headers.set("content-type", "application/json");
  const res = await fetch(`/api/v1${path}`, { ...rest, headers, credentials: "same-origin" });
  if (res.status === 204) return undefined as T;
  const body: unknown = await res.json().catch(() => null);
  if (!res.ok) {
    const e = (body as ApiError | null)?.error;
    if (res.status === 401 && !path.startsWith("/auth/"))
      window.dispatchEvent(new CustomEvent("cx:unauthenticated"));
    throw new ApiFailure(
      res.status,
      e?.code ?? "http_error",
      e?.message ?? "Não foi possível concluir. Tente de novo.",
      e?.fields,
    );
  }
  return body as T;
}
